import { render, staticRenderFns } from "./AuthWidget.vue?vue&type=template&id=a8f97066&"
import script from "./AuthWidget.vue?vue&type=script&lang=js&"
export * from "./AuthWidget.vue?vue&type=script&lang=js&"
import style0 from "./AuthWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports